<template>
  <div class="ui-contact-form component">
    <form
      v-if="!isSubmitted"
      v-on:submit.prevent="submit"
      data-email= "mail@testing.kaleidoscopesf.us"
      class="form-row gform"
      method="POST"
      :action="url"
      novalidate
    >
      <fieldset class="line-input">
        <div class="icon" :class="getIconClasses('name')">
          <span>
            <span class="s1"></span>
            <span class="s2"></span>
            <span class="s3"></span>
          </span>
        </div>
        <label for="name" v-if="!isErrorField('name')">{{ $t('form.name') }}</label>
        <input
          id="name"
          name="name"
          class="form-control"
          :class="getFieldClasses('name')"
          type="text"
          v-model.lazy.trim="contactData.name"
          @blur="onFieldBlur('name')"
        >
        <div class="error-msg" v-if="isErrorField('name')">{{ $t('error.fieldRequired', { field: $t('form.name') }) }}</div>
      </fieldset>
      <fieldset class="line-input">
        <div class="icon" :class="getIconClasses('email')">
          <span>
            <span class="s1"></span>
            <span class="s2"></span>
            <span class="s3"></span>
          </span>
        </div>
        <label for="email" v-if="!isErrorField('email')">{{ $t('form.email') }}</label>
        <input
          id="email"
          name="email"
          class="form-control"
          :class="getFieldClasses('email')"
          type="text"
          v-model.lazy.trim="contactData.email"
          @blur="onFieldBlur('email')"
          >
        <div class="error-msg" v-if="isErrorField('email')">{{ $t('error.fieldRequired', { field: $t('form.email') }) }}</div>
      </fieldset>
      <fieldset class="line-input">
        <label for="message" v-if="!isErrorField('message')">{{ $t('form.message') }}</label>
        <textarea
          id="message"
          name="message"
          class="form-control"
          :class="getFieldClasses('message')"
          v-model="contactData.message"
          @blur="onFieldBlur('message')"
          rows="3">
        </textarea>
        <div class="error-msg" v-if="isErrorField('message')">{{ $t('error.fieldRequired', { field: $t('form.message') }) }}</div>
      </fieldset>
      <!--<div class="col-xs-12" style="width: 332px;margin: 10px auto;">-->
        <!--<vue-recaptcha-->
          <!--:sitekey="googleRecaptchaApiKey"-->
          <!--ref="recaptcha"-->
          <!--v-model="contactData.recaptcha"-->
          <!--@verify="onVerify"-->
          <!--name="recaptcha">-->
        <!--</vue-recaptcha>-->
      <!--</div>-->
      <!--<div v-if="loading" class="col-xs-12 text-center">-->
        <!--<div class="lds-ring">-->
          <!--<div></div>-->
          <!--<div></div>-->
          <!--<div></div>-->
          <!--<div></div>-->
        <!--</div>-->
      <!--</div>-->
      <fieldset class="line-input">
        <button type="submit" class="btn btn-submit" :disabled="submitting">
          <span v-if="submitting">
            <PulseLoading></PulseLoading>
          </span>
          <span v-else>{{ $t('form.submit' ) }}</span>
        </button>
      </fieldset>
    </form>
    <div v-if="isSubmitted">
      <div class="alert alert-success">
        <strong>{{ $t('form.submitted' ) }}</strong>
      </div>
      <div class="alert alert-info">
        <p><strong>{{ $t('form.sentInfo' ) }}</strong></p>
        <pre>
            {{ contactData }}
        </pre>
      </div>
      <p class="text-center">
        <a href="#" class="btn btn-secondary" @click.prevent="reload()">{{ $t('form.return' ) }}</a>
      </p>
    </div>

    <!--<div class="slot-before" v-if="$slots.before" :style="inputHeight">-->
      <!--<slot name="before"></slot>-->
    <!--</div>-->

    <!--<div class="input-wrapper">-->
      <!--<label-->
        <!--:class="{ 'is-label-error': error }"-->
        <!--:for="labelId">{{ label }}-->
      <!--</label>-->

      <!--<input-->
        <!--:id="labelId"-->
        <!--:type="inputType"-->
        <!--:style="inputHeight"-->
        <!--:class="inputClasses"-->
        <!--:value="value"-->
        <!--:placeholder="placeholder"-->
        <!--v-on="listeners">-->

      <!--<div class="slot-bottom" v-if="$slots.bottom">-->
        <!--<slot name="bottom"/>-->
      <!--</div>-->
    <!--</div>-->

    <!--<div class="slot-after" v-if="$slots.after" :style="inputHeight">-->
      <!--<slot name="after"></slot>-->
    <!--</div>-->
  </div>
</template>

<script>
  import axios from 'axios'
  import VueRecaptcha from 'vue-recaptcha'
  import { required, email } from 'vuelidate/lib/validators'
  import PulseLoading from './PulseLoading'

  export default {
    name: 'UiContactForm',

    props: {
      iconClass: String
    },

    components: {
      VueRecaptcha,
      PulseLoading
    },

    data() {
      return {
        title: '',
        content: '',

        contactData: {
          name: '',
          email: '',
          message: '',
          recaptcha: '',
        },

        error: {
          invalidFields: 'Following fields have an invalid or a missing value:',
          general: 'An error happened during submit',
          generalMessage: 'Form sending failed due to technical problems. Please try again later.',
          fieldRequired: '{field} is required',
          fieldInvalid: '{field} is invalid or missing',
        },

        isSubmitted: false,
        submitting: false,
        isError: false,
        errorHeader: 'error.invalidFields',
        errors:[],

        responseMessage: null,
        responseStatus: null,
        errorMessage: null,
        loading: false,
        googleRecaptchaApiKey: '6LfpPmgUAAAAACAQAStx2R6j8el0PGce9ATs-AZk',
        url: 'https://script.google.com/macros/s/AKfycbwIuBw_Cef2uLzX_Y7de5_grnzZ5GRysSOMQQMFsg/exec',
        testUrl: 'http://www.mocky.io/v2/5b6a708b3200001000372eca',
        newurl: 'https://script.google.com/macros/s/AKfycbwIuBw_Cef2uLzX_Y7de5_grnzZ5GRysSOMQQMFsg/exec'
      }
    },

    validations: {
      contactData: {
        name: { required },
        email: { required, email },
        message: { required }
      }
    },

    watch: {
      error() {
        this.isError = this.errors.length > 0;
      }
    },

    mounted() {
      // const url = '/static/forms/email.html';
      // this.load(url);
      // this.createFormComponents();
    },
    //
    // beforeUpdate() {
    //   this.destroyFormComponents();
    // },
    //
    // updated() {
    //   this.createFormComponents();
    // },
    //
    // beforeDestroy() {
    //   this.destroyFormComponents();
    // },

    methods: {
      submit() {
        this.$v.$touch();
        if (!this.$v.$error) {
          this.sendFormData();
        } else {
          this.validationError();
        }
      },

      sendFormData () {
        this.enableSubmitLoader();
        let encoded = '';
        for (const i in this.contactData) {
          encoded = encoded + encodeURIComponent(i) + "=" + encodeURIComponent(this.contactData[i]) + "&";
        }

        axios
          .post(this.url, encoded, {
            headers: {"Content-Type": "application/x-www-form-urlencoded"},
          })
          .then(response => {
            console.log(response);
            this.submitSuccess(response);
            this.disableSubmitLoader();
          })
          .catch(error => {
            this.submitError(error);
            this.disableSubmitLoader();
            console.log(error);
          })
      },

      submitSuccess(response) {
        if (response.data.status === 200) {
          this.isSubmitted = true;
          this.isError = false;
          console.log(response.data);
        } else {
          this.errorHeader = this.error.invalidFields;
          this.errors = response.data.errors;
          this.isError = true;
        }
      },

      submitError(error) {
        this.errorHeader = this.error.general;
        this.errors = [{field: null, message: this.error.generalMessage}];
        this.isError = true;
        console.log(error);
      },

      validationError() {
        this.errorHeader = this.error.invalidFields;
        this.errors = this.getErrors();
        this.isError = true;
      },

      getErrors() {
        let errors = [];
        for (const field of Object.keys(this.contactData)) {
          try {
            if (this.getValidationField(field).$error) {
              errors.push({'field': field, 'message': null});
            }
          } catch (error) {}
        }
        return errors;
      },

      isErrorField(field) {
        try {
          if (this.getValidationField(field).$error) {
            return true;
          }
        } catch (error) {}

        return this.errors.some(el => el.field === field);
      },

      getValidationField(field) {
        if (this.$v.contactData[field]) {
          return this.$v.contactData[field];
        }
        throw Error('No validation for field' + field);
      },

      getFieldClasses(field) {
        return {'is-invalid': this.isErrorField(field) }
      },

      getIconClasses(field) {
        return {
          'cross': this.isErrorField(field),
        }

      },

      onFieldBlur(field) {
        try {
          this.getValidationField(field).$touch();
          if (this.getValidationField(field).$error) {
            if (!this.errors.some(el => el.field === field)) {
              this.errors.push({'field': field, 'message': null});
            } else {
              this.errors = this.errors.filter(el => el.field !== field);
            }
          }
        } catch (error) {}
      },

      enableSubmitLoader() {
        this.submitting = true;
      },
      disableSubmitLoader() {
        this.submitting = false;
      },

      reload() {
        window.location = '';
      },

      // sendForm() {
      //   let self = this;
      //
      //   this.$validator.validateAll().then(resultOK => {
      //     if(resultOK) {
      //       self.loading = true;
      //       let formData = new FormData();
      //       formData.append('email', this.contactData.email);
      //       formData.append('name', this.contactData.name);
      //       formData.append('message', this.contactData.message);
      //       // let formData = self.toFormData(self.contactData);
      //       axios.post("/email.php", formData, {
      //         headers: {'X-Requested-With': 'XMLHttpRequest'}
      //       }).then((response) => {
      //         self.responseMessage = response.data.message;
      //         self.responseStatus = response.data.status;
      //         self.loading = false;
      //
      //         console.log(self.responseMessage);
      //         console.log(self.responseStatus);
      //       }).catch( e => {
      //         console.log(e);
      //       });
      //     } else {
      //       self.errorMessage = "Please fill all the required fields and check the Captcha";
      //     }
      //   })
      // },
      //
      // toFormData(obj) {
      //   const formData = new FormData();
      //   for (const key in obj) {
      //     // let name = JSON.stringify(key);
      //     // let value = JSON.stringify(obj[key]);
      //     // console.log(name);
      //     // console.log(value);
      //     formData.append(key, obj[key]);
      //   }
      //   console.log(formData.get('name'));
      // },
      //
      // getMessageClass: function () {
      //   return {
      //     'alert-success': this.responseStatus,
      //     'alert-error': !this.responseStatus
      //   }
      // },
      //
      // onVerify: function(response) {
      //   this.contactData.recaptcha = response;
      // },

      // handleClick(e) {
      //   if ( e.target.tagName === 'INPUT' && e.target.type === 'submit' ) {
      //     let data = formSerialize( e.target.form, {
      //       hash: false,
      //       empty: true,
      //     });
      //
      //     data += '&' + e.target.name + '=' + encodeURIComponent( e.target.value );
      //
      //     axios.post(url, data, {
      //       headers: "'X-Requested-With': 'XMLHttpRequest'"
      //     }).then( response => {
      //       this.title = response.data.title;
      //       this.content = response.data.content;
      //       this.components = response.data.components;
      //     });
      //
      //     e.preventDefault();
      //   }
      // },

      keyDown( e ) {
        if ( e.keyCode == 38 || e.keyCode == 40 ) { // up and down keys
          if ( !this.open ) {
            this.open = true;
          } else {
            const items = this.$refs.menu.querySelectorAll( 'li a' );
            if ( items.length > 0 ) {
              let index = Array.prototype.indexOf.call( items, e.target );
              if ( e.keyCode == 38 && index > 0 )
                index--;
              else if ( e.keyCode == 40 && index < items.length - 1 )
                index++;
              if ( index < 0 )
                index = 0;
              items[ index ].focus();
            }
          }
          e.preventDefault();
        } else if ( e.keyCode == 27 ) { // Esc key
          this.$refs.button.focus();
          this.close();
        }
      }

    },

    computed: {
      isFormValid() {
        return !Object.keys(this.fields).some(key => this.fields[key].invalid);
      },
    }
  }
</script>

<style lang="scss" scoped>
.error-msg {
  color: $color-error;
}

.btn {

  &-submit {
    height: 48px;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    color: #fff;
    background: darken($light-secondary, .1);
    outline: 0;
    border: 0;
    width: 100%;
    cursor: pointer;
    text-decoration: none;
    transition: all .35s;
    margin-top: 3rem;
  }
}

.error-msg {
  animation: type 1s steps(60, end) 1s forwards, undercase-error 0.3s ease 2s forwards;
  position: absolute;
  left: 10px;
  font-size: 12px;
}

.icon {
  position: absolute;
  right: 0;
  min-height: 40px;
  min-width: 40px;
  width: 40px;
  height: 40px;
  &> span {
    display: block;
    position: relative;
    width: 40px;
    height: 40px;
    transition: transform 0.3s ease;
    overflow: hidden;
  }
  &> span > span {
    display: block;
    background-color: transparent;
    position: absolute;
    top: 0;
    left: 0;
    width: 40px;
    height: 40px;
    transition: all 0.3s ease;
    border: 1px solid transparent;
  }
}

.cross {
  &> span {
    transform: rotate(45deg);
  }
  &> span > span {
    background-color: #FE4D69;
    transform: scale(1, 0.05);
  }
  &> span > span.s3 {
    background-color: #FE4D69;
    transform: scale(0.05, 1);
  }
}

.check {
  &> span > span {
    background-color: #62D474;
    width: 16px;
    height: 1.6px;
    transform-origin: 100% 100%;
    transform: translate(-4.8px, 30px) rotate(45deg);
  }
  &> span > span.s3 {
    background-color: #62D474;
    width: 28.8px;
    transform-origin: 0 100%;
    transform: translate(14.4px, 30px) rotate(-45deg);
  }
}

@keyframes undercase-error {
  from {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
  to {
    transform: translate3d(0, 100%, 0);
    font-size: 12px;
    letter-spacing: initial;
    opacity: 1;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/UiContactForm.vue